var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"w1",class:_vm.classes,attrs:{"viewBox":_vm.viewBox}},[_c('use',{attrs:{"xmlns:xlink":"http://www.w3.org/1999/xlink","xlink:href":("#" + _vm.icon),"x":"0","y":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }